(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("zlib"), (function webpackLoadOptionalExternalModule() { try { return require("jquery"); } catch(e) {} }()));
	else if(typeof define === 'function' && define.amd)
		define("swea", ["zlib", "jquery"], factory);
	else if(typeof exports === 'object')
		exports["swea"] = factory(require("zlib"), (function webpackLoadOptionalExternalModule() { try { return require("jquery"); } catch(e) {} }()));
	else
		root["swea"] = factory(root["Zlib"], root["jquery"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__99222__, __WEBPACK_EXTERNAL_MODULE__89714__) => {
return 